import { FormControl, FormGroup, Validators } from '@angular/forms';

export class BusinessComplianceSettingForm extends FormGroup<{
  id: FormControl<undefined | number>;
  CompanyId: FormControl<undefined | number>;
  businessVerified: FormControl<undefined | boolean | null>;
  address: FormControl<undefined | 'Verified' | null>;
  governmentWatchlist: FormControl<undefined | number | null>;
  secretaryOfState: FormControl<
    undefined | 'In Good Standing' | 'Inactive' | null
  >;
  liens: FormControl<undefined | number | null>;
  bankruptcy: FormControl<undefined | number | null>;
  isW9Checked: FormControl<undefined | boolean>;
  requester: FormControl<
    undefined | 'Matching' | 'Likely Matching' | 'Not Matching' | null
  >;
  complianceSettingType: FormControl<undefined | string>;
  CompanyComplianceTypeId: FormControl<undefined | number>;
}> {
  constructor() {
    super({
      id: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      CompanyId: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      businessVerified: new FormControl<undefined | boolean | null>(false),
      address: new FormControl<undefined | 'Verified' | null>(null),
      governmentWatchlist: new FormControl<undefined | number | null>(null),
      secretaryOfState: new FormControl<
        undefined | 'In Good Standing' | 'Inactive' | null
      >(null),
      liens: new FormControl<undefined | number | null>(null),
      bankruptcy: new FormControl<undefined | number | null>(null),
      isW9Checked: new FormControl<undefined | boolean>(false, {
        nonNullable: true
      }),
      requester: new FormControl<
        undefined | 'Matching' | 'Likely Matching' | 'Not Matching' | null
      >(null),
      complianceSettingType: new FormControl<undefined | string>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      CompanyComplianceTypeId: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      )
    });
  }
}
